// extracted by mini-css-extract-plugin
export default {"createNoteHolder":"DriverEntry_createNoteHolder__7tape","btnHolder":"DriverEntry_btnHolder__jDUXX"};